import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./sass/main.scss";

// Components
import MainHome from "./MainHome";
import Contact from "./components/Contact";
import CustomCursor from "./components/CustomCursor";

function App() {
  return (
    <Router>
      <CustomCursor />
      <Switch>
        <Route path="/" exact component={MainHome} />
        <Route path="/contact" component={Contact} />
      </Switch>
    </Router>
  );
}

export default App;
